import { Grid } from '@mui/material';
import React, { Fragment, useState } from 'react';
import LedgerFormView from '../../../components/account/reports/ledger/LedgerFormView';
import LedgerListView from '../../../components/account/reports/ledger/LedgerListView';

const AccountLedgerReportCreateListView = () => {
    const [onLedgerList, setOnLedgerList] = useState([]);
    return (
        <Fragment>
            <Grid container spacing={1}>
                <Grid item xl={12} lg={12} xs={12} sm={12}>
                    <LedgerFormView setOnLedgerList={setOnLedgerList} />
                </Grid>
                <Grid item xl={12} lg={12} xs={12} sm={12}>
                    <LedgerListView onLedgerList={onLedgerList} />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default AccountLedgerReportCreateListView